import toPascalCase from 'to-pascal-case'

export function getView(schema, table) {
  return `${toPascalCase(schema)}${toPascalCase(table)}`
}
